// extracted by mini-css-extract-plugin
export default {"flip_box":"FlipBox_flip_box__QrMWC","inner":"FlipBox_inner__beBcM","turn":"FlipBox_turn__RN-WL","front":"FlipBox_front__i6Vd-","back":"FlipBox_back__jmth8"};